import React from "react";

class Start extends React.Component {
    render() {
        return (
            <>
                <div className="host-container">
                    <div className="top-bar">
                        <div>NAME - {this.props.user}</div>
                        <div>ROOM - {this.props.code}</div>
                    </div>
                    <div className="localFont">
                        WAIT FOR HOST TO START
                    </div>
                </div>
            </>
        );
    }
}

export default Start;